import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { BottomNav } from '@/components/layout/bottom-nav';
import { CommandPalette } from '@/components/layout/command-palette';
import { Header } from '@/components/layout/header';
import { Required2faBanner } from '@/components/layout/required-2fa-banner';
import { Sidebar } from '@/components/layout/sidebar';
import { sessionQueryOptions } from '@/lib/auth';
import { MobileSidebarProvider } from '@/lib/mobile-sidebar';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context }) => {
    const user = await context.queryClient.ensureQueryData(sessionQueryOptions);
    if (!user) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <MobileSidebarProvider>
      <div className="flex min-h-screen">
        <Sidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <Header />
          <Required2faBanner />
          {/* pb-16 on mobile reserves space for BottomNav (h-14) + safe-area. */}
          <main className="flex-1 bg-slate-50 pb-16 sm:pb-0 dark:bg-slate-950">
            <Outlet />
          </main>
        </div>
        <BottomNav />
        <CommandPalette />
      </div>
    </MobileSidebarProvider>
  );
}
